module.exports = __webpack_public_path__ + "media/images/ClearAngel_Master_Subscription_Agreement_US-502161b1a6d0b31926db78a1d08f15d4.pdf";